export interface AboutSection {
  title: string;
  content: string;
}

const KNOWN_HEADERS = [
  'About me',
  'Conditions I enjoy working with',
  'Treatment modalities, techniques, or focus areas',
  'Some things I love'
] as const;

export const PILL_SECTIONS = new Set<string>(['Some things I love']);

const HEADER_REGEX = new RegExp(
  `(${KNOWN_HEADERS.map((h) => h.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`
);

export function parseAbout(html: string): AboutSection[] {
  if (!html) return [];

  const text = new window.DOMParser().parseFromString(html, 'text/html').body.textContent ?? '';

  if (!text.trim()) return [];

  const parts = text.split(HEADER_REGEX).filter((s) => s.trim());

  const sections: AboutSection[] = [];
  let i = 0;
  while (i < parts.length) {
    const part = parts[i].trim();
    const isHeader = (KNOWN_HEADERS as readonly string[]).includes(part);
    if (isHeader && i + 1 < parts.length) {
      const nextPart = parts[i + 1].trim();
      const nextIsHeader = (KNOWN_HEADERS as readonly string[]).includes(nextPart);
      if (!nextIsHeader) {
        sections.push({ title: part, content: nextPart });
        i += 2;
      } else {
        i += 1;
      }
    } else if (!isHeader && sections.length === 0) {
      sections.push({ title: '', content: part });
      i++;
    } else {
      i++;
    }
  }

  return sections;
}
